import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const ClientContext = createContext(null);

export function ClientProvider({ children }) {
  const [clients, setClients] = useState([]);
  const [activeId, setActiveId] = useState(
    () => localStorage.getItem("postelier_active_client") || null
  );
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/clients");
      setClients(data);
      setActiveId((prev) => {
        if (prev && data.some((c) => c.id === prev)) return prev;
        return data[0]?.id || null;
      });
    } catch (err) {
      console.error("Failed to load brands:", err);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const setActive = (id) => {
    setActiveId(id);
    if (id) localStorage.setItem("postelier_active_client", id);
  };

  const activeClient = clients.find((c) => c.id === activeId) || null;

  const value = useMemo(
    () => ({ clients, activeClient, activeId, setActive, refresh, loading }),
    [clients, activeClient, activeId, refresh, loading]
  );

  return <ClientContext.Provider value={value}>{children}</ClientContext.Provider>;
}

export const useClient = () => useContext(ClientContext);
